/**
 * Returns the given string with the first character capitalized.
 *
 * @param str - String to capitalize
 * @returns string
 */
export function capitalize(str: string): string {
  if (!str) {
    return str;
  }
  if (str.length === 1) {
    return str.toUpperCase();
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
}
